var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10,
      strokeDasharray: "6,2"
    },
    d: "M343.349,191.886 c0,10.38-1.28,20.46-3.69,30.1c-0.25,1.02-0.52,2.04-0.81,3.05c-0.27,0.99-0.55,1.97-0.85,2.95 c-3.07,10.06-7.38,19.58-12.76,28.38c-0.54,0.87-1.08,1.74-1.64,2.59c-0.54,0.85-1.1,1.69-1.67,2.52 c-13.14,19.3-31.6,34.68-53.28,44.05c-2.66,1.15-5.37,2.21-8.13,3.18c-12.81,4.49-26.59,6.93-40.93,6.93 c-31.17,0-59.64-11.52-81.4-30.55c-5.92-5.17-11.35-10.9-16.19-17.1c-13.33-17.07-22.28-37.74-25.16-60.3 c-0.04-0.34-0.08-0.67-0.12-1c-0.01-0.05-0.02-0.1-0.01-0.14c-0.58-4.81-0.87-9.7-0.87-14.66c0-3.72,0.16-7.41,0.49-11.05 c0.25-2.92,0.61-5.81,1.08-8.66c0.07-0.47,0.14-0.94,0.23-1.41c7.71-44.87,39.58-81.47,81.74-95.95c1.89-0.65,3.81-1.26,5.74-1.82 c2.89-0.83,5.82-1.57,8.79-2.19c2.77-0.59,5.58-1.08,8.41-1.48c0.05,0,0.09-0.01,0.13-0.01c3.32-0.46,6.67-0.79,10.06-0.98 c0.12-0.01,0.24-0.01,0.36-0.02c2.23-0.12,4.47-0.18,6.72-0.18c0.54,0,1.08,0,1.62,0.01c0.51,0.01,1.02,0.02,1.52,0.03 c9.78,0.24,19.27,1.62,28.36,4.01c2.14,0.56,4.26,1.17,6.36,1.85C307.279,90.026,343.349,136.746,343.349,191.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.193,237.649c-2.601-3.899-7.037-6.469-12.076-6.469c-3.495,0-6.7,1.237-9.205,3.295 c-2.505-2.058-5.71-3.295-9.205-3.295c-5.919,0-11.002,3.549-13.259,8.632c-7.711,0.341-13.863,6.682-13.863,14.478 c0,8.014,6.497,14.511,14.51,14.511c2.492,0,4.836-0.63,6.884-1.736c2.649,3.507,6.84,5.785,11.574,5.785 c6.04,0,11.215-3.692,13.399-8.941c2.281,1.494,5.004,2.37,7.934,2.37c8.014,0,14.511-6.497,14.511-14.511 C369.399,244.892,364.612,239.147,358.193,237.649z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.574,
    y: 279.783,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.504,
    height: 6.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.677,
    y: 283.879,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.232,
    y: 277.767,
    style: {
      fill: "#FFFFFF"
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M112.793,268.663l-31.06,21.48c-2.354,1.628-5.581,1.054-7.229-1.286l-2.539-3.605 c-1.689-2.399-1.068-5.719,1.376-7.344l31.656-21.054"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 201.567,
    cy: 66.955,
    r: 26.99
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 235.294,
    cy: 66.955,
    r: 21.515
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 126.108,
    cy: 250.422,
    r: 23.393
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M76.624,177.934l0.352,1.964c0.238,1.331,1.28,2.373,2.612,2.612 l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964 c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352 c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964 C76.191,177.666,76.576,177.666,76.624,177.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M329.863,99.515l0.352,1.964c0.238,1.331,1.28,2.373,2.612,2.612 l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964 c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352 c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964 C329.431,99.247,329.815,99.247,329.863,99.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M241.278,331.841l0.352,1.964 c0.238,1.331,1.28,2.373,2.612,2.612l1.964,0.352c0.268,0.048,0.268,0.433,0,0.481l-1.964,0.352 c-1.331,0.238-2.373,1.28-2.612,2.612l-0.352,1.964c-0.048,0.268-0.433,0.268-0.481,0l-0.352-1.964 c-0.238-1.331-1.28-2.373-2.612-2.612l-1.964-0.352c-0.268-0.048-0.268-0.433,0-0.481l1.964-0.352 c1.331-0.238,2.373-1.28,2.612-2.612l0.352-1.964C240.845,331.573,241.23,331.573,241.278,331.841z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 94.996,
    cy: 113.693,
    r: 1.952
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 358.749,
    cy: 180.685,
    r: 1.952
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAF3FC"
    },
    d: "M104.831,262.253l-30.964,21.454l2.633,3.799c0,0-0.055,2.522,4.658-0.271 c5.072-3.514,26.579-18.543,26.579-18.543s0.714-1.357,0-2.45C107.003,265.163,104.831,262.253,104.831,262.253z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    cx: 182.397,
    cy: 335.056,
    r: 1.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M145.307,256.162c1.587-5.628,0.741-11.894-2.85-17.076 c-6.384-9.212-19.027-11.505-28.239-5.123s-11.504,19.024-5.12,28.235c6.384,9.212,19.027,11.505,28.239,5.123 c3.6-2.494,6.143-5.944,7.524-9.771"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M109.518,244.604c-1.9,5.13-1.348,11.076,2.005,15.914 c5.456,7.872,16.26,9.832,24.132,4.378c7.872-5.454,9.831-16.257,4.375-24.129c-5.456-7.872-16.26-9.832-24.132-4.378 c-2.274,1.576-4.055,3.597-5.306,5.866"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M73.867,283.706l2.936,4.237 c0.597,0.861,1.779,1.076,2.64,0.479l27.845-19.292c0.861-0.597,1.076-1.779,0.479-2.64l-2.936-4.237 c-0.597-0.861-1.779-1.076-2.64-0.479l-27.845,19.292C73.484,281.663,73.27,282.845,73.867,283.706z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 105.593,
    y1: 263.581,
    x2: 108.626,
    y2: 261.479
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 106.791,
    y1: 265.31,
    x2: 109.841,
    y2: 263.197
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 321.529,
    y: 280.088,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.239,
    y: 283.879,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.794,
    y: 277.767,
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    width: 1.549,
    height: 6.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    d: "M346.306,261.079c0.195,0.044,0.349,0.196,0.428,0.379 c0.042,0.044,0.081,0.095,0.114,0.158c0.472,0.921,1.595,1.226,2.491,1.581c1.236,0.49,2.437,1.047,3.757,1.276 c1.382,0.24,2.846,0.281,4.227,0.012c1.38-0.268,2.623-0.915,3.917-1.435c0.084-0.034,0.162-0.046,0.235-0.047 c1.548-1.192,2.811-2.77,3.84-4.413c0.295-0.47,0.571-0.953,0.824-1.447c0.235-0.46,0.53-0.965,0.608-1.484 c0.073-0.491-0.032-0.964,0.109-1.455c0.071-0.245,0.174-0.479,0.292-0.706c-1.917-3.657-5.748-6.153-10.163-6.153 c-1.935,0-3.756,0.481-5.355,1.327c-2.08-2.917-5.488-4.821-9.343-4.821c-0.573,0-1.136,0.043-1.686,0.124 c-1.851-0.795-3.889-1.236-6.03-1.236c-5.432,0-10.199,2.833-12.914,7.099c-1.19-0.539-2.508-0.846-3.899-0.846 c-5.234,0-9.477,4.243-9.477,9.477c0,3.531,1.935,6.606,4.8,8.236c0.342,0.005,0.684,0.018,1.026,0.04 c0.309-0.029,0.616-0.064,0.916-0.088c0.801-0.065,1.575-0.14,2.359-0.329c0.789-0.19,1.549-0.462,2.316-0.724 c0.637-0.217,1.267-0.403,1.761-0.883c0.772-0.749,1.845-0.067,1.925,0.747c0.202,0.147,0.369,0.348,0.45,0.591 c0.159,0.476,0.547,0.795,0.921,1.11c0.455,0.384,0.91,0.772,1.393,1.121c0.96,0.692,1.999,1.29,3.125,1.666 c2.028,0.676,4.188,0.828,6.311,0.702c0.509-0.294,1.117-0.372,1.7-0.49c0.927-0.188,1.739-0.711,2.504-1.246 c1.596-1.116,3.076-2.393,4.267-3.944c0.023-0.03,0.05-0.057,0.075-0.085c0.59-1.08,0.987-2.136,1.359-3.352 C345.597,261.187,345.947,260.997,346.306,261.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M346.117,233.25L346.117,233.25 c-3.631,0-6.913,1.57-9.203,4.064c-2.289-2.494-5.571-4.064-9.203-4.064h0c-5.424,0-10.068,3.502-11.788,8.356 c-0.236-0.013-0.474-0.022-0.714-0.022h0c-6.876,0-12.502,5.626-12.502,12.502v0c0,0.762,0.069,1.509,0.201,2.234"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M304.466,260.457c2.186,3.663,6.191,6.13,10.744,6.13h0 c2.76,0,5.318-0.908,7.392-2.438c2.115,3.923,6.266,6.606,11.013,6.606h0c6.03,0,11.097-4.327,12.253-10.029 c2.274,2.327,5.44,3.778,8.93,3.778h0c6.876,0,12.502-5.626,12.502-12.502v0c0-6.108-4.44-11.226-10.252-12.293 c-1.759-3.16-4.848-5.491-8.496-6.219"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 320.023,
    y1: 280.086,
    x2: 320.023,
    y2: 265.613
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 336.733,
    y1: 283.876,
    x2: 336.733,
    y2: 270.359
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    x1: 353.286,
    y1: 277.768,
    x2: 353.286,
    y2: 264.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.967,
    y: 280.088,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.677,
    y: 283.879,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.232,
    y: 277.767,
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    width: 6.111,
    height: 6.111
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    cx: 235.212,
    cy: 66.64,
    r: 7.956
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "#EAF3FC"
    },
    d: "M218.364,69.997c-0.552-0.025-1.075-0.133-1.568-0.395 c-0.34-0.181-0.664-0.489-0.858-0.823c-0.222-0.381-0.256-0.708-0.306-1.137c-0.068-0.582-0.026-1.196,0.018-1.78 c0.041-0.538,0.107-1.113,0.418-1.575c0.216-0.321,0.465-0.591,0.815-0.769c0.408-0.208,0.672-0.253,1.129-0.295 c0.113-0.01,0.227-0.01,0.342-0.012c-0.701-3.433-2.437-6.488-4.863-8.831c1.232-2.176,3.798-6.919,3.798-6.919v-0.958 l-1.896-1.228l-4.196,7.248c-1.579-1.069-3.346-1.88-5.243-2.373l-0.341-6.567l-0.103-1.514l-0.414-0.799h-2.144l-0.162,8.377 c-0.375-0.025-0.75-0.05-1.131-0.05c-1.722,0-3.381,0.261-4.948,0.735l-2.595-5.058l-1.364-1.801l-2.386,0.392l4.037,7.371 c-1.885,0.89-3.581,2.106-5.01,3.59l-6.901-3.767h-1.075l-0.981,1.602l7.215,4.285c-1.195,1.723-2.082,3.676-2.578,5.779 l-8.236,0.205l-0.546,0.772v1.734l8.429-0.561c-0.06,0.58-0.102,1.165-0.102,1.761c0,1.834,0.297,3.596,0.833,5.251l-6.606,3.355 l-0.896,1.281l1.22,1.896l7.279-4.13c0.874,1.733,2.028,3.295,3.413,4.626l-3.818,7.047l0.375,1.112l1.669,1.019l3.721-7.568 c1.775,1.261,3.799,2.187,5.987,2.695v8.176l0.73,0.607h1.962v-8.386c0.389,0.026,0.775,0.059,1.171,0.059 c1.736,0,3.406-0.273,4.984-0.756l3.786,6.755l0.875,0.425l1.963-0.874l-4.531-7.091 C213.63,79.896,217.281,75.412,218.364,69.997z M211.574,70.199c-1.162,3.964-4.409,7.226-9.762,7.226 c-3.628,0-6.282-1.499-7.984-3.692c-1.253-1.299-2.132-2.816-2.622-4.561c-0.126-0.941-0.253-1.882-0.379-2.823 c0.006-1.917,0.489-3.704,1.45-5.36c0.554-0.717,1.107-1.433,1.661-2.149c0.754-0.812,1.621-1.43,2.593-1.869 c1.446-0.834,3.202-1.333,5.282-1.333c4.516,0,7.527,2.317,9.059,5.414c0.468,0.794,0.834,1.648,1.091,2.565l0.379,2.823 C212.39,67.777,212.125,69.027,211.574,70.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M216.079,53.746c-0.481-0.538-0.991-1.048-1.529-1.529 l2.563-4.439c0.361-0.625,0.147-1.425-0.479-1.787l-4.583-2.646c-0.626-0.361-1.425-0.147-1.787,0.479l-2.561,4.437 c-0.681-0.224-1.377-0.414-2.09-0.562v-5.121c0-0.722-0.586-1.308-1.308-1.308h-5.293c-0.722,0-1.308,0.586-1.308,1.308v5.121 c-0.712,0.148-1.409,0.338-2.09,0.562l-2.561-4.437c-0.361-0.625-1.161-0.84-1.787-0.479l-4.583,2.646 c-0.626,0.361-0.84,1.161-0.479,1.787l2.563,4.439c-0.538,0.481-1.048,0.991-1.529,1.529l-4.439-2.563 c-0.626-0.361-1.425-0.147-1.787,0.479l-2.646,4.583c-0.361,0.626-0.147,1.425,0.479,1.787l4.437,2.561 c-0.224,0.681-0.414,1.377-0.562,2.09h-5.12c-0.722,0-1.308,0.585-1.308,1.308v5.292c0,0.722,0.586,1.308,1.308,1.308h5.12 c0.148,0.712,0.338,1.409,0.562,2.09l-4.437,2.562c-0.626,0.361-0.84,1.161-0.479,1.787l2.646,4.583 c0.361,0.625,1.161,0.84,1.787,0.479l4.439-2.563c0.481,0.537,0.991,1.048,1.529,1.528l-2.563,4.439 c-0.361,0.626-0.147,1.425,0.479,1.787l4.583,2.646c0.626,0.361,1.425,0.147,1.787-0.479l2.561-4.437 c0.681,0.224,1.377,0.414,2.09,0.562v5.121c0,0.722,0.586,1.308,1.308,1.308h5.293c0.722,0,1.308-0.585,1.308-1.308v-5.121 c0.712-0.148,1.409-0.338,2.09-0.562l2.561,4.437c0.361,0.625,1.161,0.84,1.787,0.479l4.583-2.646 c0.626-0.361,0.84-1.161,0.479-1.787l-2.563-4.439c0.538-0.481,1.048-0.991,1.529-1.529 M201.659,77.344 c-5.913,0-10.707-4.794-10.707-10.707s4.794-10.707,10.707-10.707s10.707,4.794,10.707,10.707S207.572,77.344,201.659,77.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#C0DAF5",
      strokeMiterlimit: 10
    },
    d: "M253.8,63.596h-3.938c-0.114-0.548-0.26-1.083-0.433-1.607 l3.412-1.97c0.481-0.278,0.646-0.893,0.368-1.374l-2.035-3.525c-0.278-0.481-0.893-0.646-1.374-0.368l-3.414,1.971 c-0.37-0.414-0.762-0.806-1.176-1.176l1.971-3.414c0.278-0.481,0.113-1.096-0.368-1.374l-3.525-2.035 c-0.481-0.278-1.096-0.113-1.374,0.368l-1.97,3.412c-0.524-0.172-1.059-0.319-1.607-0.433v-3.938c0-0.556-0.45-1.006-1.006-1.006 h-4.071c-0.556,0-1.006,0.45-1.006,1.006v3.938c-0.548,0.114-1.083,0.26-1.607,0.433l-1.97-3.412 c-0.278-0.481-0.893-0.646-1.374-0.368l-3.525,2.035c-0.481,0.278-0.646,0.893-0.368,1.374l1.971,3.414 c-0.413,0.37-0.806,0.762-1.176,1.176l-3.414-1.971c-0.481-0.278-1.096-0.113-1.374,0.368l-2.035,3.525 c-0.278,0.481-0.113,1.096,0.368,1.374l3.412,1.97c-0.172,0.524-0.319,1.059-0.433,1.607h-3.938c-0.556,0-1.006,0.45-1.006,1.006 v4.071c0,0.556,0.45,1.006,1.006,1.006h3.938c0.114,0.548,0.26,1.083,0.433,1.607l-3.412,1.97 c-0.481,0.278-0.646,0.893-0.368,1.374l2.035,3.525c0.278,0.481,0.893,0.646,1.374,0.368l3.414-1.971 c0.37,0.413,0.762,0.806,1.176,1.176l-1.971,3.414c-0.278,0.481-0.113,1.096,0.368,1.374l3.525,2.035 c0.481,0.278,1.096,0.113,1.374-0.368l1.97-3.412c0.524,0.172,1.059,0.319,1.607,0.433v3.938c0,0.556,0.45,1.006,1.006,1.006 h4.071c0.556,0,1.006-0.45,1.006-1.006v-3.938c0.548-0.114,1.083-0.26,1.607-0.433l1.97,3.412 c0.278,0.481,0.893,0.646,1.374,0.368l3.525-2.035c0.481-0.278,0.646-0.893,0.368-1.374l-1.971-3.414 c0.413-0.37,0.806-0.762,1.176-1.176l3.414,1.971c0.481,0.278,1.096,0.113,1.374-0.368l2.035-3.525 c0.278-0.481,0.113-1.096-0.368-1.374l-3.412-1.97c0.172-0.524,0.319-1.06,0.433-1.607h3.938c0.556,0,1.006-0.45,1.006-1.006 v-4.071C254.806,64.046,254.356,63.596,253.8,63.596z M235.294,74.872c-4.548,0-8.235-3.687-8.235-8.235s3.687-8.235,8.235-8.235 c4.548,0,8.235,3.687,8.235,8.235S239.843,74.872,235.294,74.872z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 219.194,
    cy: 191.172,
    r: 123.994
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000100380760402007423440000001876750579718955954_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000100380760402007423440000001876750579718955954_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M365.081,93.918c-14.2-5.612-28.814-9.435-37.075-5.982c-3.988,1.667-10.004,6.446-5.484,19.719 c1.866,5.478,4.007,11.441,6.274,17.753c5.922,16.49,12.634,35.18,16.288,50.642c5.028,21.275,2.008,27.408-0.24,29.17 c-2.076,1.628-9.416,3.744-32.676-11.696c-27.208-18.06-49.209-23.642-65.391-16.588c-17.914,7.809-21.416,27.981-21.556,28.836 l7.533,1.235l-3.766-0.618l3.765,0.627c0.029-0.169,3.033-17.007,17.136-23.11c13.461-5.826,33.538-0.301,58.059,15.976 c20.716,13.753,33.936,17.357,41.607,11.344c13.164-10.318,2.678-43.147-13.573-88.399c-2.256-6.282-4.387-12.216-6.232-17.634 c-2.896-8.503,0.081-9.748,1.202-10.216c8.364-3.496,32.793,4.664,62.237,20.791c27.034,14.807,50.504,32.141,54.593,40.32 l6.828-3.414c-5.662-11.324-33.907-30.54-57.754-43.601C389.603,105.103,377.5,98.826,365.081,93.918z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M234.62,200.904 l-7.166-2.832c-1.168-0.461-2.488,0.111-2.95,1.279l-11.38,28.791c-0.462,1.168,0.111,2.488,1.279,2.95l7.166,2.832 c1.168,0.461,2.488-0.111,2.95-1.279l11.38-28.791C236.36,202.686,235.787,201.365,234.62,200.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M235.599,218.318l-20.766-8.207c-3.384-1.337-7.211,0.322-8.548,3.705l-8.208,20.766c-1.337,3.384,0.322,7.211,3.705,8.549 l20.766,8.207c3.384,1.337,7.211-0.322,8.548-3.705l8.208-20.766C240.642,223.483,238.983,219.655,235.599,218.318z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.86,
    y: 221.459,
    transform: "matrix(0.93 0.3675 -0.3675 0.93 103.1848 -62.2812)",
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 44.507,
    height: 36.631
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M246.333,229.73 l-47.136-18.628c-1.239-0.49-2.641,0.118-3.13,1.357l-3.006,7.604c-0.49,1.239,0.118,2.641,1.357,3.131l47.136,18.628 c1.239,0.49,2.641-0.118,3.13-1.357l3.006-7.604C248.18,231.621,247.572,230.22,246.333,229.73z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000100380760402007423440000001876750579718955954_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M211.688,163.878l2.944,2.528c0.583,0.501,1.462,0.434,1.963-0.149l19.395-22.574c0.501-0.583,0.434-1.462-0.149-1.963 l-2.944-2.528c-0.583-0.501-1.462-0.434-1.963,0.149l-19.395,22.574C211.039,162.498,211.105,163.377,211.688,163.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F86DD",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M198.375,152.443l2.944,2.528c0.583,0.501,1.462,0.434,1.963-0.149l19.395-22.574c0.501-0.583,0.434-1.462-0.149-1.963 l-2.944-2.528c-0.583-0.501-1.462-0.434-1.963,0.149l-19.395,22.574C197.725,151.064,197.792,151.943,198.375,152.443z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M39.522,236.724c10.291,8.839,21.45,16.296,29.39,15.798c3.833-0.24,10.274-2.504,10.338-14.96 c0.026-5.141-0.038-10.769-0.107-16.727c-0.178-15.564-0.38-33.205,1.047-47.248c1.963-19.322,6.282-23.592,8.682-24.418 c2.216-0.763,8.995-0.406,24.035,19.316c17.594,23.069,34.443,34.15,50.082,32.931c17.312-1.349,26.116-17.266,26.483-17.943 l-5.966-3.227l2.983,1.613l-2.978-1.621c-0.073,0.134-7.491,13.396-21.106,14.421c-12.996,0.979-28.247-9.495-44.103-30.287 c-13.395-17.566-23.448-24.434-31.636-21.617c-14.053,4.835-14.793,35.443-14.304,78.156c0.068,5.93,0.132,11.53,0.106,16.615 c-0.041,7.98-2.902,8.159-3.979,8.227c-8.039,0.504-26.178-13.447-46.211-35.543c-18.394-20.288-33.06-41.661-34.116-49.716 l-6.725,0.881c1.462,11.152,19.59,35.493,35.816,53.389C22.185,220.207,30.522,228.994,39.522,236.724z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M180.357,184.994l4.808,4.13c0.952,0.818,2.387,0.709,3.206-0.243l17.595-20.478c0.818-0.952,0.709-2.388-0.243-3.206 l-4.808-4.13c-0.952-0.818-2.387-0.709-3.206,0.243l-17.595,20.478C179.295,182.74,179.404,184.176,180.357,184.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M184.963,170.404l13.935,11.968c2.76,2.37,6.919,2.055,9.289-0.704l11.971-13.933c2.372-2.76,2.056-6.92-0.705-9.291 l-13.935-11.968c-2.76-2.37-6.919-2.055-9.289,0.704l-11.971,13.933C181.887,163.872,182.203,168.033,184.963,170.404z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.071,
    y: 141.593,
    transform: "matrix(-0.7586 -0.6515 0.6515 -0.7586 262.6606 413.0427)",
    style: {
      fill: "#C0DAF5",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 39.542,
    height: 32.545
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2F86DD",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M178.915,157.4 l33.752,28.988c1.011,0.868,2.534,0.753,3.402-0.258l4.384-5.102c0.868-1.011,0.753-2.534-0.258-3.402l-33.752-28.988 c-1.011-0.868-2.534-0.752-3.402,0.258l-4.384,5.102C177.788,155.008,177.904,156.532,178.915,157.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorimage);
export default __webpack_public_path__ + "static/media/errorimage.d9f7bd76ef3387427667d2d4f58d9bfc.svg";
export { ForwardRef as ReactComponent };